import { useSelector } from "react-redux";
import { selectExportForm } from "./selector";

export const useExportForm = () => useSelector(selectExportForm);
